var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.flag)?_c('div',{staticClass:"indexAll"},[_c('div',{staticClass:"container"},[_c('div',{staticStyle:{"margin-top":"80px"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.aboutList[0].hContent)}})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }